KXL.module('GamesApp.Gallery', function(Gallery, KXL, Backbone, Marionette, $, _) {
	Gallery.View = Marionette.ItemView.extend({
		template: '#game-gallery-template'
	});
});
